import { Typography, Box, makeStyles, Grid, Button } from "@material-ui/core";
import { ToggleButtonGroup } from "@material-ui/lab";
import { useContext, useEffect, useState } from "react";
import { Error, Loading } from "ra-ui-materialui";
import React from "react";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import { useTranslate } from "react-admin";

import {
  getMemberType,
  loadPaymentMemberState,
  removePaymentMemberState,
  savePaymentMemberState,
} from "../../../utils";
import heartImage from "../../../assets/icons/heart.png";
import SfBreadcrumbs from "../../../components/SfBreadcrumbs";
import MasterLayoutContainer from "../../../components/MasterLayoutContainer";
import cashIcon from "../../../assets/icons/paymentIcon/disabledIcon/Cash.png";
import cardIcon from "../../../assets/icons/paymentIcon/disabledIcon/Credit.png";
// import bWalletIcon from "../../../assets/icons/paymentIcon/disabledIcon/BWallet.png";
import transferIcon from "../../../assets/icons/paymentIcon/disabledIcon/Transfer.png";
// import truemoney from "../../../assets/icons/paymentIcon/disabledIcon/Truewallet.png";
import splitPayment from "../../../assets/icons/paymentIcon/disabledIcon/Split.png";
import enablecashIcon from "../../../assets/icons/paymentIcon/enableIcon/Cash.png";
import enablecardIcon from "../../../assets/icons/paymentIcon/enableIcon/Credit.png";
import enableTransferIcon from "../../../assets/icons/paymentIcon/enableIcon/Transfer.png";
import enablesplitPayment from "../../../assets/icons/paymentIcon/enableIcon/Split.png";
import GridMenu from "../payment-method/GridMenu";
import CartPanel from "../../../components/CartPanel";
import TransferPage from "../payment-method/payment-method-page/Transfer/TransferPage";
import CreditDebit from "../payment-method/payment-method-page/Card/CreditDebit";
import { PaymentCreateContext } from "../payment-addproduct/PaymentCreateContext";
import { createPaymentTransaction } from "../../../hooks/useMakeaPayment";
//import PaymentConfirm from "./payment-method-page/PaymentConfirm/PaymentConfirm";
import PaymentConfirm from "../payment-method/payment-method-page/PaymentConfirm/PaymentConfirm";
import SimpleSplitPayment from "../payment-method/simple-split-payment";
import usePaymentMethods from "../../../hooks/usePaymentMethods";
import useProducts from "../../../hooks/useProducts";
import { isPaymentCardType } from "../../../utils";

import Cash from "../payment-method/payment-method-page/Cash";
import { useHistory } from "react-router-dom";
import OffersDialog from "../../../components/OffersDialog";
import useSFAlert from "../../../hooks/useSFAlert";
import settings from "../../../utils/settings";
import PointasCashDialog from "../../../components/PointasCashDialog";

const useStyles = makeStyles((theme) => ({
  allContainer: {
    width: "100%",
    height: "100%",
    backgroundColor: theme.layout.main.backgroundColor,
  },
  leftPanel: {
    width: "100%",
    height: "100%",
    overflow: "auto",
    display: "flex",
    backgroundColor: theme.layout.leftPanel.backgroundColor,
    zIndex: 0,
  },
  rightPanel: {
    width: "100%",
    paddingTop: 0,
    paddingLeft: 0,
    display: "flex",
    justifyContent: "center",
    backgroundColor: theme.layout.rightPanel.backgroundColor,
    overflow: "auto",
    height: "100%",
    zIndex: 1,
  },
  backgroundPaper: {
    flex: 2,
    margin: "0px auto 10px",
    backgroundColor: theme.lightGray,
    height: 0,
  },
  containerToggleButton: {
    display: "flex",
    margin: " 0 20px",
  },

  toggleButton: {
    flex: "1",
    marginTop: "15px",
    color: theme.white,
    fontSize: 16,
    height: 38,
  },

  container: {
    width: 138 * 3 + 80,
    // backgroundColor: "red",
    display: "grid",
    gridTemplateColumns: "33% 33% 33%",
    margin: " 0px auto",
  },
  bottomToggleButton: {},
  textTitle: {
    marginLeft: 29,
    marginTop: 43,
    fontSize: 20,
  },
  iconButton: {
    maxWidth: 54,
    maxHeight: 54,
    minWidth: 54,
    minHeight: 54,
    padding: 0,
    width: 54,
    height: 54,
  },
}));

const PaymentLite = () => {
  const classes = useStyles();
  const [state, dispatch] = useContext(PaymentCreateContext);
  const history = useHistory();
  const translate = useTranslate();
  //const [paymentAmount, setPaymentAmount] = useState(0);
  const { branchId } = settings();

  useEffect(() => {
    //Case refresh the page
    dispatch({ type: "RESET_STATE" });
    if (!history.location.state) {
      const [memberData, error] = loadPaymentMemberState();
      if (error || !memberData) {
        dispatch({
          type: "SHOW_WALKIN",
          payload: null,
        });
      } else {
        dispatch({
          type: "SET_MEMBER",
          payload: memberData,
        });
      }
    } //Navigate to page
    else if (!history.location.state.member) {
      removePaymentMemberState();
      // dispatch({
      //   type: "SHOW_WALKIN",
      //   payload: null,
      // });
    } else {
      savePaymentMemberState(history.location.state.member);
      dispatch({
        type: "SET_MEMBER",
        payload: history.location.state.member,
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!branchId) {
    return (
      <Typography style={{ margin: "auto" }}>
        {translate("ra.text.pleaseSelectBranch")}
      </Typography>
    );
  }

  return (
    <MasterLayoutContainer>
      <Grid container className={classes.allContainer}>
        <Grid item xs={12} sm={8} className={classes.leftPanel}>
          <LeftPanel
          //amountValue={paymentAmount}
          //onPaymentAmountChange={setPaymentAmount}
          />
        </Grid>
        <Grid item xs={12} sm={4} className={classes.rightPanel}>
          {<CartPanel lite />}
        </Grid>
        <PaymentConfirm fullPaymentBeforeChange={getPaymentLiteAmount(state)} />
      </Grid>
      <PointasCashDialog
        open={state.showPointasCash}
        onClose={() => dispatch({ type: "HIDE_POINT_AS_CASH" })}
      />
    </MasterLayoutContainer>
  );
};

const LeftPanel = () => {
  const classes = useStyles();
  const [state, dispatch] = useContext(PaymentCreateContext);

  const { paymentMethods, error, loading } = usePaymentMethods();
  const [bottomToggleButtonValue, setBottomToggleValue] = useState("");
  const [openTransferDialog, setTransferDialogOpen] = useState(false);
  const [openSplitDialog, setSplitDialogOpen] = useState(false);
  const [openCardDialog, setOpenCardDialog] = useState(false);
  const [openCashDialog, setOpenCashDialog] = useState(false);
  const [alert] = useSFAlert();
  const translate = useTranslate();

  const {
    products,
    loading: productLoading,
    error: productError,
  } = useProducts();
  useEffect(() => {
    if (state.items.length === 0 && products && products.length !== 0)
      dispatch({
        type: "ADD_PRODUCT",
        payload: {
          id: products[0].id,
          code: products[0].code,
          skip_stock: true,
          image_url: null,
          name: products[0].name,
          category: {
            id: products[0].category.id,
            name: products[0].category.name,
          },
        },
        qty: 1,
        customPrice: 0,
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [products]);

  const onAmountChange = (amount) => {
    setBottomToggleValue("");
    dispatch({
      type: "REMOVE_PAYMENT_CHANNEL",
    });
    dispatch({
      type: "CHANGE_PAYMENTLITE_AMOUNT_PAYMENT",
      amount: amount,
    });
  };

  const handleBottomToggleValue = (newValue) => {
    if (bottomToggleButtonValue === newValue) {
    } else {
      setBottomToggleValue(newValue);
    }
  };

  const handleClickDialogOpen = (name) => {
    if (name === "Cash") {
      //Do Full Cash payment
      setOpenCashDialog(true);
      return dispatch({
        type: "SET_PAYMENT_CHANNEL",
        payload: {
          type: "Cash",
          amount: getPaymentLiteAmount(state),
        },
      });
    }
    if (name === "Other") {
      return dispatch({
        type: "SET_PAYMENT_CHANNEL",
        payload: {
          type: "Other",
          amount: getPaymentLiteAmount(state),
        },
      });
    }
    if (isPaymentCardType(name)) {
      return setOpenCardDialog(true);
    }
    if (name === "Transfer") {
      return setTransferDialogOpen(true);
    }
    if (name === "Split Payment") {
      return setSplitDialogOpen(true);
    }
  };

  function handleDialogClose(name) {
    if (name === "Cash") {
      setOpenCashDialog(false);
    }
    if (isPaymentCardType(name)) setOpenCardDialog(false);

    if (name === "Transfer") {
      setTransferDialogOpen(false);
    }
    if (name === "Split Payment") {
      setSplitDialogOpen(false);
    }
    setBottomToggleValue("");
    dispatch({
      type: "REMOVE_PAYMENT_CHANNEL",
    });
  }

  if (loading || productLoading) return <Loading />;

  if (error || productError) return <Error error={error} />;
  if (products && products.length === 0)
    return (
      <Typography style={{ margin: "auto" }}>
        Please create one product first
      </Typography>
    );

  let completePaymentMethods = paymentMethods.map((pMethod) => {
    if (pMethod.name === "Cash") {
      return {
        disabledIcon: cashIcon,
        enabledIcon: enablecashIcon,
        name: "Cash", //Also used as value
        disabled: false,
        label: translate("ra.text.paymentMethod.cash"), //to display in button
      };
    }

    if (isPaymentCardType(pMethod.name)) {
      return {
        disabledIcon: cardIcon,
        enabledIcon: enablecardIcon,
        name: "Credit / Debit Card",
        disabled: false,
        label: translate("ra.text.paymentMethod.card"), //to display in button
      };
    }

    if (pMethod.name === "Transfer") {
      return {
        disabledIcon: transferIcon,
        enabledIcon: enableTransferIcon,
        name: "Transfer",
        disabled: false,
        label: translate("ra.text.paymentMethod.transfer"), //to display in button
      };
    }
    return {
      disabledIcon: null,
      enabledIcon: null,
      name: pMethod.name,
      disabled: false,
      label: pMethod.name,
    };
  });

  //Split payment button
  if (completePaymentMethods.length > 1) {
    completePaymentMethods.push({
      disabledIcon: splitPayment,
      enabledIcon: enablesplitPayment,
      name: "Split Payment",
      disabled: false,
      label: translate("ra.text.paymentMethod.split"), //to display in button
    });

    completePaymentMethods.push({
      disabledIcon: null,
      enabledIcon: null,
      name: "Other",
      disabled: false,
      label: translate("ra.text.paymentMethod.other"), //to display in button
    });
  }

  return (
    <>
      <Box style={{ display: "flex", width: "100%" }}>
        <Box classes={{ root: classes.backgroundPaper }} elevation>
          <SfBreadcrumbs path="/Payment/&user/Payment lite" lower />
          <Typography className={classes.textTitle} align="center">
            Add Payment
          </Typography>

          <Box
            style={{
              display: "grid",
              gridTemplateColumns: "426px 54px",
              alignItems: "baseline",
              width: "auto",
              gap: "14px",
              margin: "0 auto",
              justifyContent: "center",
            }}
          >
            <InputMoneyTextField onChange={onAmountChange} />
            <Button
              color="primary"
              className={classes.iconButton}
              variant="contained"
              onClick={() => {
                dispatch({
                  type: "SHOW_OFFERS",
                });
              }}
              disabled={
                state.items.length <= 0 || getMemberType(state) === "guest"
              }
            >
              <img
                src={heartImage}
                className={classes.iconOfferButton_image}
                alt="heart"
                style={{ pointerEvents: "none" }}
              />
            </Button>
          </Box>
          <hr />
          <Typography className={classes.textTitle} align="center">
            {translate("ra.text.paymentOption.selectPaymentMethod")}
          </Typography>

          <ToggleButtonGroup
            value={bottomToggleButtonValue}
            // exclusive
            classes={{ root: classes.container }}
          >
            {completePaymentMethods.map((pMethod, index) => {
              return (
                <GridMenu
                  key={index}
                  nameOfButton={pMethod.label}
                  icon={
                    bottomToggleButtonValue === pMethod.name
                      ? pMethod.enabledIcon
                      : pMethod.disabledIcon
                  }
                  disabled={pMethod.disabled}
                  value={pMethod.name}
                  onClick={() => {
                    handleBottomToggleValue(pMethod.name);
                    handleClickDialogOpen(pMethod.name);
                  }}
                  selected={bottomToggleButtonValue === pMethod.name}
                />
              );
            })}
          </ToggleButtonGroup>
          {/* </Box> */}
        </Box>
      </Box>
      <OffersDialog alert={alert} />
      <CreditDebit
        paymentValue={getPaymentLiteAmount(state)}
        openDialog={openCardDialog}
        handleDialogClose={() => handleDialogClose("Credit / Debit Card")}
        onSubmit={(card) => {
          dispatch({ type: "SET_PAYMENT_CHANNEL", payload: card });
          setOpenCardDialog(false);
        }}
      />
      <TransferPage
        paymentValue={getPaymentLiteAmount(state)}
        openDialog={openTransferDialog}
        handleDialogClose={() => handleDialogClose("Transfer")}
        onSubmit={(bank) => {
          dispatch({ type: "SET_PAYMENT_CHANNEL", payload: bank });
          setTransferDialogOpen(false);
        }}
      />
      <Cash
        openDialog={openCashDialog}
        onClose={() => handleDialogClose("Cash")}
        onSubmit={() => setOpenCashDialog(false)}
        cashValue={getPaymentLiteAmount(state)}
        noChange
      />
      <SimpleSplitPayment
        openDialog={openSplitDialog}
        onClose={() => handleDialogClose("Split Payment")}
        paymentValue={getPaymentLiteAmount(state)}
        onSubmit={(payments) => {
          dispatch({ type: "SET_PAYMENT_CHANNELS", payload: payments });
          setSplitDialogOpen(false);
        }}
      ></SimpleSplitPayment>
    </>
  );
};

const useTextFieldStyles = makeStyles((theme) => ({
  text: {
    color: theme.orange,
    fontSize: 20,
  },
  textInput: {
    fontSize: 32,
    color: theme.orange,
    margin: "29px auto",
    justifyContent: "space-around",
    display: "flex",
    width: "426px",
    height: "54px",
    border: "1px solid rgba(250, 153, 23, 0.19)",
    boxSizing: "border-box",
    boxShadow: "inset 0px 4px 4px rgba(0, 0, 0, 0.25)",
    borderRadius: 5,
    backgroundColor: theme.midGray,
  },
}));

function InputMoneyTextField({ onChange }) {
  const classes = useTextFieldStyles();
  const [value, setValue] = useState();

  return (
    <OutlinedInput
      classes={{ root: classes.textInput }}
      endAdornment={<Typography className={classes.text}>THB</Typography>}
      value={value}
      type="number"
      defaultValue={0}
      onChange={(e) => {
        setValue(e.target.value);
        onChange(e.target.value);
      }}
    />
  );
}

const getPaymentLiteAmount = (state) => {
  if (state.items.length > 0) {
    const data = createPaymentTransaction(state);

    return data.payment.paid_amount;
  } else {
    return 0;
  }
};

export default PaymentLite;
